__turbopack_context__.v({
  "container": "_3E1NLG_container",
  "description": "_3E1NLG_description",
  "descriptionSmall": "_3E1NLG_descriptionSmall",
  "group": "_3E1NLG_group",
  "groupList": "_3E1NLG_groupList",
  "groupTitle": "_3E1NLG_groupTitle",
  "mktuClassButton": "_3E1NLG_mktuClassButton",
});
